import styled from 'styled-components';

const BudgetCalculatorStyles = styled.section`
  position: relative;
  margin-bottom: 50px;
  .headline-wrap {
    position: relative;
    border-bottom: 1px solid #e4e5e7;
    display: flex;
    margin-top: 60px;
    padding-bottom: 20px;
    margin-bottom: 60px;
    h3 {
      font-weight: 600;
      font-size: 25px;
      line-height: 30px;
      letter-spacing: -0.35px;
      color: #25292d;
      font-family: 'source-sans-pro';
    }
  }
  .slider .fill {
    top: 6px;
  }
  .chart_container .chart_container_header {
    font-family: 'source-sans-pro';
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    letter-spacing: -0.3px;
    color: #25292d;
  }
  .chart_center .calculated_total {
    font-family: 'source-sans-pro';
    font-style: normal;
    font-weight: 600;
    font-size: 29px;
    line-height: 48px;
    letter-spacing: -0.35px;
    color: #25292d;
  }
  .field input {
    background: transparent;
    font-family: 'source-sans-pro';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 29px;
    color: #25292d;
  }
  .field .suffix,
  .field .prefix {
    font-family: 'source-sans-pro';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 29px;
    color: #25292d;
  }
  .chart_container .value {
    font-family: 'source-sans-pro';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: -0.3px;
    color: #25292d;
  }
  .DXTooltip {
    p {
      color: white;
    }
  }
  .budgetCalc {
    width: 100%;
    margin: 0;
    .chart_container_header {
      @media screen and (max-width: 1099px) {
        margin-bottom: 30px;
      }
    }
  }
`;

export default BudgetCalculatorStyles;
